import { apiEndpoints, CommandResult } from '../amorg-common'
import { IncidentListing, IncidentPriority, IncidentStatus, IncidentType, IncidentView } from '../amorg-common/DTOs/Incident';
import { commandAuthWrapper, queryAuthWrapper } from "./serverApiHelpers";

export const incidentClientApi = {
    createIncident,
    updateIncident,
    toggleIncidentHidden,
    sendIncidentReporterMessage,
    sendIncidentPublicReporterMessage,
    getIncidents,
    getIncident
}

async function createIncident(
    id: string,
    type: IncidentType,
    title: string,
    description: string,
    solutionDescription:string,
    anonymousSelected:boolean,
    email:string,
    name:string,
    notificationsSelected:boolean,
    fileUploadSlotId= ''
): Promise<CommandResult>
{
    return commandAuthWrapper(`${apiEndpoints.incidents_type.replace(':type', type)}`, 'POST',
        { id, type, title, description, solutionDescription, anonymousSelected, email, name, notificationsSelected, fileUploadSlotId });
}

async function updateIncident(
    id: string,
    status: IncidentStatus,
    priority: IncidentPriority
): Promise<CommandResult>
{
    return commandAuthWrapper(`${apiEndpoints.incidents_id.replace(':id', id)}`, 'PUT',
        { status, priority });
}

async function toggleIncidentHidden(
    id: string,
    hidden: boolean
): Promise<CommandResult>
{
    return commandAuthWrapper(`${apiEndpoints.incidents_id_hidden.replace(':id', id)}`, 'PUT',
        { hidden });
}

async function sendIncidentReporterMessage(
    id: string,
    message: string
): Promise<CommandResult>
{
    return commandAuthWrapper(`${apiEndpoints.incidents_id_messages.replace(':id', id)}`, 'POST',
        { message });
}

async function sendIncidentPublicReporterMessage(
    siteId: string,
    id: string,
    message: string
): Promise<CommandResult>
{
    return commandAuthWrapper(`${apiEndpoints.incidents_id_messages_siteId.replace(':id', id).replace(':siteId', siteId)}`, 'POST',
        { message });
}

async function getIncidents(): Promise<IncidentListing[]>
{
    const result:IncidentListing[] = await queryAuthWrapper(`${apiEndpoints.incidents}`);
    return result.map(incident => ({
        ...incident,
        created: new Date(incident.created)
    }));
}

async function getIncident(id:string): Promise<IncidentView | null>
{
    const result:IncidentView = await queryAuthWrapper(`${apiEndpoints.incidents_id.replace(':id', id)}`);
    if(!result)
        return null;

    return {
        ...result,
        created: new Date(result.created),
        history: result.history.map(entry => ({
            ...entry,
            timestamp: new Date(entry.timestamp)
        })),
        messages: result.messages.map(message => ({
            ...message,
            created: new Date(message.created)
        })),
        images: result.images.map(image => ({
            ...image,
            created: new Date(image.created)
        }))
    };
}
